import axios from '../axios.jsx';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import { useAuth } from '../AuthContext';
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import 'bootstrap-daterangepicker/daterangepicker.css';
import "../styles/btn.css";

/* ─── Constantes ─── */
const URI           = 'blogs/';
const BLOGS_PER_PAGE = 10;

/* ═══════════════════════════════════════════════════════════════════ */
const CompShowBlogs = () => {

  /* ── Estado: datos ── */
  const [blogs, setBlog] = useState([]);

  /* ── Estado: UI / navegación ── */
  const navigate               = useNavigate();
  const [pageNumber, setPageNumber] = useState(0);

  /* ── Estado: usuario ── */
  const { user } = useAuth();

  /* ── Estado: modales ── */
  const [showModal,  setShowModal]  = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);

  /* ── Estado: formularios ── */
  const [selecteddate,  setselected]     = useState('');
  const [selecteddate2, setSelectedDate] = useState('');
  const [selectedRange, setSelectedRange] = useState({ start: '', end: '' });
  const [sending,  setSending]  = useState(false);
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState('');

  /* ─────────────────────────── Carga inicial ─────────────────────── */
  useEffect(() => { getBlogs(); }, []);

  /* ─────────────────────────── Fetch data ────────────────────────── */
  const getBlogs = async () => {
    try {
      const res = await axios.get(URI);
      setBlog(res.data.reverse());
    } catch (err) {
      console.error('Error fetching blogs:', err);
    }
  };

  const deleteBlog = async id => {
    try {
      await axios.delete(`${URI}${id}`);
      getBlogs();
    } catch (err) {
      console.error(`Error deleting blog ${id}:`, err);
    }
  };

  /* ─────────────────────────── Acciones ──────────────────────────── */
  const handleDeleteBlog = id => {
    Swal.fire({
      title:              '¿Estás seguro?',
      text:               'Esta acción no se puede deshacer.',
      icon:               'warning',
      showCancelButton:   true,
      confirmButtonColor: '#d33',
      cancelButtonColor:  '#3085d6',
      confirmButtonText:  'Sí, eliminarlo',
    }).then(result => {
      if (result.isConfirmed) {
        deleteBlog(id);
        Swal.fire({ title: 'Eliminado', text: 'El monitoreo ha sido eliminado.', icon: 'success', timer: 2000, showConfirmButton: false });
      }
    });
  };

  const handleExportMatriz = async () => {
    try {
      const response = await axios.get('/export', { responseType: 'blob', withCredentials: true });
      const url  = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href  = url;
      link.setAttribute('download', 'Monitoreo_de_medios.xlsx');
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (err) {
      console.error('Error al exportar:', err);
    }
  };

  const handleGeneratePDF = async () => {
    if (!selecteddate) return alert('Por favor, seleccione una fecha válida.');
    try {
      const response = await axios.get(`/generate-pdf?selectedDate=${selecteddate}`, { responseType: 'blob' });
      const url  = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href  = url;
      link.setAttribute('download', `MMCR ${selecteddate}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch {
      alert('No se encontraron registros de esta fecha.');
    }
    setShowModal(false);
    setselected('');
  };

  const SendMail = async () => {
    if (!selecteddate2) return alert('Por favor, seleccione una fecha válida.');
    try {
      setSending(true);
      await axios.get(`/sendmail?selectedDate2=${selecteddate2}`, { responseType: 'blob' });
      alert('Enviado correctamente.');
      setShowModal2(false);
      setSelectedDate('');
    } catch {
      alert('No se encontraron registros de esta fecha.');
    } finally {
      setSending(false);
    }
  };

  const handleExportResumen = async () => {
    const { start, end } = selectedRange;
    if (!start || !end) return alert('Por favor, selecciona un rango de fechas.');
    setLoading(true);
    setError('');
    try {
      const response = await axios.get('/carpeta', {
        params:       { startDate: start, endDate: end },
        responseType: 'blob',
      });
      const url  = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href  = url;
      link.setAttribute('download', `Reporte_Monitoreos_${start}_a_${end}.zip`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      setError('Error al generar el reporte. Intenta nuevamente.');
      console.error(err);
    } finally {
      setLoading(false);
      setShowModal3(false);
    }
  };

  /* ─────────────────────────── Paginación ────────────────────────── */
  const pageCount    = Math.ceil(blogs.length / BLOGS_PER_PAGE);
  const changePage   = ({ selected }) => setPageNumber(selected);
  const displayBlogs = blogs
    .slice(pageNumber * BLOGS_PER_PAGE, (pageNumber + 1) * BLOGS_PER_PAGE)
    .map(blog => (
      <tr key={blog.id}>
        <td>{blog.createdAt}</td>
        <td>{blog.monitor}</td>
        <td className="text-truncate" style={{ maxWidth: 200 }}>{blog.titulo}</td>
        <td>
          <Link to={`/edit/${blog.id}`} className="btn btn-sm btn_aleja me-1">
            <i className="fas fa-edit"></i>
          </Link>
          <button onClick={() => handleDeleteBlog(blog.id)} className="btn btn-sm btn-danger">
            <i className="fas fa-trash-alt"></i>
          </button>
        </td>
      </tr>
    ));

  /* ═══════════════════════════════════════════════════════════════════
     RENDER
  ═══════════════════════════════════════════════════════════════════ */
  return (
    <div className="container">
      {user && <p className="mt-2">Bienvenido, {user}</p>}

      {/* ── Botones de acción ── */}
      <div className="mb-3 mt-2">
        <Link to="/create" className="btn btn-sm btn_aleja me-1">
          <i className="fas fa-plus"></i> Agregar
        </Link>
        <Button size="sm" className="btn_aleja me-1" onClick={() => setShowModal(true)}>
          <i className="fa-solid fa-print"></i> Reporte PDF
        </Button>
        <Button size="sm" className="btn_aleja me-1" onClick={() => setShowModal2(true)}>
          <i className="fa-solid fa-envelope"></i> Enviar correo
        </Button>
        <Button size="sm" className="btn_aleja me-1" onClick={handleExportMatriz}>
          Exportar matriz
        </Button>
        <Button size="sm" className="btn_aleja" onClick={() => setShowModal3(true)}>
          Exportar resumen
        </Button>
      </div>

      {/* ── Modal: generar PDF ── */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title className="col text-center">Exportar Reporte PDF</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label className="mb-1">Fecha del reporte</label>
          <input
            type="date"
            className="form-control"
            required
            value={selecteddate}
            onChange={e => setselected(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn_outline_aleja" onClick={() => setShowModal(false)}>Cerrar</Button>
          <Button className="btn_aleja"         onClick={handleGeneratePDF}>Exportar</Button>
        </Modal.Footer>
      </Modal>

      {/* ── Modal: enviar correo ── */}
      <Modal show={showModal2} onHide={() => setShowModal2(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title className="col text-center">Enviar reporte por correo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label className="mb-1">Fecha del reporte</label>
          <input
            type="date"
            className="form-control"
            required
            value={selecteddate2}
            onChange={e => setSelectedDate(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn_outline_aleja" onClick={() => setShowModal2(false)}>Cerrar</Button>
          <Button className="btn_aleja" onClick={SendMail} disabled={sending}>
            {sending ? 'Enviando...' : 'Enviar'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ── Modal: exportar resumen por rango ── */}
      <Modal show={showModal3} onHide={() => setShowModal3(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Seleccionar rango de fechas</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label className="mb-1">Fecha de inicio</label>
          <input
            type="date"
            className="form-control mb-2"
            value={selectedRange.start}
            onChange={e => setSelectedRange({ ...selectedRange, start: e.target.value })}
          />
          <label className="mb-1">Fecha de fin</label>
          <input
            type="date"
            className="form-control"
            value={selectedRange.end}
            onChange={e => setSelectedRange({ ...selectedRange, end: e.target.value })}
          />
          {error && <div className="text-danger mt-2">{error}</div>}
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn_outline_aleja" onClick={() => setShowModal3(false)}>Cerrar</Button>
          <Button className="btn_aleja" onClick={handleExportResumen} disabled={loading}>
            {loading ? 'Generando...' : 'Exportar'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ── Tabla ── */}
      <div className="table-responsive">
        <table className="table table-striped">
          <thead style={{ background: '#28b6ea', color: '#fff' }}>
            <tr>
              <th>Fecha de noticia</th>
              <th>Monitor de medios</th>
              <th>Título de noticia</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>{displayBlogs}</tbody>
        </table>
      </div>

      {/* ── Paginación ── */}
      <ReactPaginate
        previousLabel={<i className="fas fa-chevron-left"></i>}
        nextLabel={<i className="fas fa-chevron-right"></i>}
        pageCount={pageCount}
        onPageChange={changePage}
        containerClassName="pagination justify-content-center"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        disabledClassName="page-item disabled"
        activeClassName="page-item active"
      />
    </div>
  );
};

export default CompShowBlogs;